<template>
  <div class="flex min-h-screen flex-col">
    <LayoutAppHeader class="z-30" />
    <main class="flex flex-auto flex-col [&>*]:flex-1">
      <slot />
    </main>
    <LayoutAppFooter />
  </div>
</template>
